import { comics } from '@/mocks/comics';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CategoryGrid from './components/CategoryGrid';
import LatestUpdates from './components/LatestUpdates';
import PopularRecommendations from './components/PopularRecommendations';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '韩漫之家 - 专业韩漫在线阅读平台',
          description: '韩漫之家作为专业的韩漫网站，专注于免费下拉式漫画在线观看，采用智能加载技术，确保阅读体验流畅舒适。',
          url: 'http://rfeff.com/',
          isPartOf: {
            '@type': 'WebSite',
            name: '韩漫之家',
            url: 'http://rfeff.com/',
            potentialAction: {
              '@type': 'SearchAction',
              target: 'http://rfeff.com/search?q={search_term_string}',
              'query-input': 'required name=search_term_string',
            },
          },
          mainEntity: {
            '@type': 'ItemList',
            itemListElement: comics.slice(0, 8).map((comic, index) => ({
              '@type': 'ListItem',
              position: index + 1,
              item: {
                '@type': 'ComicSeries',
                name: comic.title,
                url: `http://rfeff.com/comic/${comic.slug}`,
                author: { '@type': 'Person', name: comic.author },
                image: comic.coverImage,
                aggregateRating: {
                  '@type': 'AggregateRating',
                  ratingValue: comic.rating.toString(),
                  bestRating: '5',
                },
              },
            })),
          },
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: '韩漫之家',
          url: 'http://rfeff.com/',
          description: '专业的韩漫在线阅读平台，提供免费下拉式漫画阅读体验',
          logo: 'http://rfeff.com/logo.png',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'hello@rfeff.com',
            telephone: '400-888-6666',
            contactType: 'customer service',
          },
          sameAs: [],
        })}
      </script>

      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '韩漫之家是什么？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '韩漫之家是一个专注于韩漫在线阅读的专业平台，提供免费下拉式漫画阅读体验，采用智能加载技术确保阅读流畅舒适。',
              },
            },
            {
              '@type': 'Question',
              name: '如何使用下拉式阅读？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '打开任意一部漫画后，页面会自动进入下拉式阅读模式。只需向下滚动页面，漫画内容就会自动加载，无需翻页点击。',
              },
            },
            {
              '@type': 'Question',
              name: '韩漫之家需要注册吗？',
              acceptedAnswer: {
                '@type': 'Answer',
                text: '不需要！韩漫之家目前完全免费开放，所有漫画均可直接在线阅读，无需注册登录。',
              },
            },
          ],
        })}
      </script>

      <Navbar />

      <main>
        <HeroSection />
        <StatsSection />
        <CategoryGrid />
        <LatestUpdates />
        <PopularRecommendations />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}